import useApiPrivate from './useApiPrivate';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth';

const LOGOUT_URL = 'api/v1/user/signout';

export const useLogout = () => {
  const ApiPrivate = useApiPrivate();
  const navigate = useNavigate();
  const { setAuth } = useAuth();
    
    const logout = async () => {
        await ApiPrivate.post(LOGOUT_URL)
          .then(function(response) {
            setAuth('');
            localStorage.removeItem('auth');
            navigate('/login');
          })
    }
  return logout;
}
